import React from 'react';

import { Icons } from '@icons/icons';

import { IDestinationFolderForMove } from '../interfaces';

import styles from './SelectFolderItem.module.scss';

interface ISelectFolderItem {
	folder: IDestinationFolderForMove;
	onSelect: (data: IDestinationFolderForMove) => void;
	depth?: number;
}

const BASE_PADDING = 10;
const INDENT_STEP = 25;

const SelectFolderItem = ({
	folder,
	onSelect,
	depth,
}: ISelectFolderItem) => {
	const { folderId, folderName, folderHasContent } = folder;

	const onFolderClick = () => onSelect({ folderId, folderName, folderHasContent });

	return (
		<div
			className={styles.folderItem}
			onClick={onFolderClick}
			style={{ paddingLeft: depth ? depth * INDENT_STEP : BASE_PADDING }}
		>
			<div>
				{folderHasContent ? Icons.folderIcon() : Icons.folderEmpty()}
			</div>
			{folderName}
		</div>
	);
};

export default SelectFolderItem;
